import { render, staticRenderFns } from "./signAsk.vue?vue&type=template&id=1de52acd&"
import script from "./signAsk.vue?vue&type=script&lang=js&"
export * from "./signAsk.vue?vue&type=script&lang=js&"
import style0 from "./signAsk.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports